export default "__VITE_ASSET__CJTnT48k__"